import React from "react";
import {
    Container,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
    Button,
    Tabs,
    Tab,
    Box
} from "@mui/material";
import { useSelector } from "react-redux";
import { formatCurrencyDisplay } from '../../utils/moneyFormat';
import './EstimateView.css';
import PointListTable from "./PointListTable";
import { useUpdateInvoiceStatus } from '../../hooks/useInvoices';
import TabPanel from '../../components/TabPanel';

function EstimateView({ item, handleInvoiceClose, selectedCompanyValues }) {
    const userData = useSelector((state) => state.UserReducer.user);
    const company = useSelector((state) => state.CompanyReducer.userCompanies[0]);
    const updateInvoiceStatus = useUpdateInvoiceStatus();
    let data = [];
    let invoiceTotal = 0;
    let taxTotal = 0;
    let finalTotal = 0;
    let pointTypeTotal = 0;
    let creditAdjustment = 0;
    if (item?.invoiceValues != undefined) {
        data = JSON?.parse(item?.invoiceValues)

        creditAdjustment = data.creditAdjustment;

        pointTypeTotal = data.pointTypeTotal;

        for (let i = 0; i < data.items.length; i++) {
            invoiceTotal += data.items[i].total;
        }
        for (let i = 0; i < data.taxes.length; i++) {
            taxTotal += Number(data.taxes[i].total);
        }
        finalTotal = taxTotal + invoiceTotal
    };

    let pointData = [];
    if (item?.pointList != undefined) {
        if(item?.pointList != ""){
            pointData = JSON?.parse(item?.pointList)
        }
    };

    let rejectInvoice = {
        id: item.estimateId,
        isInvoiceAccepted: 3,
        OpenInvoice: true,
    };
    let acceptInvoice = {
        id: item.estimateId,
        isInvoiceAccepted: 2,
        OpenInvoice: true,
    };

    function rejectEstimate() {
        updateInvoiceStatus.mutate({
            invoice: rejectInvoice,
            handleInvoiceClose,
            currentStatus: item.isInvoiceAccepted,
            recall: false,
        });
    };
    function acceptEstimate() {
        updateInvoiceStatus.mutate({
            invoice: acceptInvoice,
            handleInvoiceClose,
            currentStatus: item.isInvoiceAccepted,
            recall: false,
        });
    };

    //
    //For File name selection in invoice//
    //
    function getLastItem(thePath) {
        if (thePath == null || thePath == "") return "";
        var index = thePath.lastIndexOf('/') + 1;
        return thePath.substring(index);
    };

    const fileReport = useSelector((state) => state.FileReducer.file);
    const [results, setResults] = React.useState(fileReport.file);
    const [value, setValue] = React.useState(0);
    const [summary, setSummary] = React.useState(fileReport.summary);

    const handleTabChange = (event, newValue) => {
        setValue(newValue);
    };

    React.useEffect(() => {
        setResults(fileReport.file);
        setSummary(fileReport.summary);
    }, [fileReport.file, fileReport.summary]);

    return (
        <Container style={{ backgroundColor: 'lightgray', maxWidth: '100vw', position: 'fixed', height: '100%' }}>
            <Container className='estimatePage' maxWidth="sm" style={{ padding: 20, width: '75vw', display: 'flex', flexDirection: 'column', overflowY: 'scroll', height: 'inherit' }}>
                <Box sx={{ width: '95%' }}>
                    <Tabs value={value} onChange={handleTabChange} centered style={{ borderBottom: '2px solid black', paddingBottom: '10px' }}>
                        <Tab label="Estimate Review" />
                        {item?.isProcessed != 2 &&
                            <Tab label="Validation & Summary" />
                        }
                    </Tabs>
                    <TabPanel value={value} index={0} style={{}}>
                        <Container>
                            <Typography variant="h4" align="right">
                                Estimate Review
                            </Typography>
                            <p style={{ display: "flex", justifyContent: 'right', width: "100%" }}>
                                <span style={{ marginRight: 50 }}>Date: {data.date}</span>
                                <span># {data?.estimateNumber}</span>
                            </p>
                            <div style={{ display: 'flex' }}>
                                <div style={{ flex: 1, margin: 2 }}>
                                    <div style={{ flex: 1, margin: 2 }}>
                                        <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', padding: 10 }}>
                                            <h4 style={{ display: "flex", justifyContent: 'left' }}>From Processor:</h4>
                                            <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>{data?.processorInfo?.name}</span></span>
                                            <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>{data?.processorInfo?.street}</span></span>
                                            <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>{data?.processorInfo?.city} {data?.processorInfo?.state} {data?.processorInfo?.zip}</span></span>
                                            <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>{data?.processorInfo?.country}</span></span>
                                            <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>{data?.processorInfo?.email}</span></span>
                                            <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>{data?.processorInfo?.phoneNumber}</span></span>
                                        </div>
                                    </div>
                                    <div style={{ flex: 1, margin: 2 }}>
                                        <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', padding: 10 }}>
                                            <h4 style={{ display: "flex", justifyContent: 'left' }}>To Customer:</h4>
                                            <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>Company: {data?.customerInfo?.userCompany}</span></span>
                                            <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>User: {data?.customerInfo?.customerName}</span></span>
                                            <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>Email: {data?.customerInfo?.companyEmail}</span></span>
                                            <br />
                                        </div>
                                    </div>
                                </div>
                                <div style={{ flex: 1, margin: 2 }}>
                                </div>
                            <PointListTable pointList={pointData} name={item.name} id={item.id} pointTypeTotal={pointTypeTotal}/>
                            </div>
                            <br />
                            <Typography variant="body1">
                                <b>Estimate</b>
                            </Typography>
                            <br />
                            <Table>
                                <TableHead>
                                    <TableRow><TableCell colSpan={7}></TableCell></TableRow>
                                    <TableRow>
                                        <TableCell className="estimateTableCellVariant">Item</TableCell>
                                        <TableCell className="estimateTableCellVariant">Description</TableCell>
                                        <TableCell className="estimateTableCellVariant">Qty</TableCell>
                                        <TableCell className="estimateTableCellVariant">U/M</TableCell>
                                        <TableCell className="estimateTableCellVariant">Rate</TableCell>
                                        <TableCell className="estimateTableCellVariant">Amount</TableCell>
                                        <TableCell className="estimateTableCellVariant"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.items?.map((item, i) => (
                                        <TableRow key={`item-${item?.itemName}-${i}`}>
                                            <TableCell className="estimateTableCellVariant">{item?.itemName}</TableCell>
                                            <TableCell className="estimateTableCellVariant">{item?.description}</TableCell>
                                            <TableCell className="estimateTableCellVariant">{item?.quantity}</TableCell>
                                            <TableCell className="estimateTableCellVariant">{item?.unit}</TableCell>
                                            <TableCell className="estimateTableCellVariant">{item?.rate}</TableCell>
                                            <TableCell className="estimateTableCellVariant"> 
                                                {formatCurrencyDisplay(Number(item?.quantity) * item?.rate)}
                                            </TableCell>
                                            <TableCell className="estimateTableCellVariant"></TableCell>
                                        </TableRow>
                                    ))}
                                    <TableRow>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell>Estimate Sub-Total</TableCell>
                                        <TableCell>{formatCurrencyDisplay(invoiceTotal)}</TableCell>
                                        <TableCell></TableCell> 
                                        {/**totals will need to account for which fees are in use above, make this dynamic */}
                                    </TableRow>
                                    {data?.taxes.map((item, i) => (
                                        <TableRow key={`tax-${item?.itemName}-${i}`}>
                                            <TableCell>{item.itemName}</TableCell>
                                            <TableCell>{item.description}</TableCell>
                                            <TableCell></TableCell>
                                            <TableCell>{item.unit}</TableCell>
                                            <TableCell>{item.rate}</TableCell>
                                            <TableCell>{formatCurrencyDisplay(invoiceTotal*item.rate)}</TableCell>
                                            <TableCell></TableCell>
                                        </TableRow>
                                    ))}
                                    <TableRow>
                                        <TableCell className="estimateTableCellVariant"></TableCell>
                                        <TableCell className="estimateTableCellVariant"></TableCell>
                                        <TableCell className="estimateTableCellVariant"></TableCell>
                                        <TableCell className="estimateTableCellVariant"></TableCell>
                                        <TableCell className="estimateTableCellVariant"><b>Total:</b></TableCell>
                                        <TableCell className="estimateTableCellVariant">{formatCurrencyDisplay(data?.finalTotal)}</TableCell>
                                        <TableCell className="estimateTableCellVariant"></TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                            <br />
                        </Container>
                        <span>Accepting Estimate: Agree to payment amount and accept Estimate. Plans will become avalible for download after Estimate has been Accepted.</span>
                        <br />
                        <Button onClick={() => rejectEstimate()}>Reject</Button>
                        <Button onClick={() => acceptEstimate()}>Accept</Button>
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <Box m={2} sx={{display:'flex', flexDirection: 'row', justifyContent: 'center', height: '100%', minHeight: '300px' }}>
                            <div style={{ margin: 20, width:'75%', overflowX:'scroll' }}>
                                <h4 style={{ textAlign: 'left' }}>Validation:</h4>
                                <pre style={{ textAlign: 'left', textWrap:'pretty' }}>
                                    {results}
                                </pre>
                            </div>
                            <div style={{ margin: 20, width:'25%' }}>
                                <h4 style={{ textAlign: 'left' }}>Summary:</h4>
                                <pre style={{ textAlign: 'left' }}>
                                    {summary}
                                </pre>
                            </div>
                        </Box>
                    </TabPanel>
                </Box>
            </Container>
        </Container>
    )
}

export default EstimateView;